import client from "../config/axios";

export const getCompetences = async ({ grade, subject }) => {
  const response = await client.get(`/competence/${subject}/${grade}`);
  const competences = response?.data?.length ? response.data : [];
  return competences;
};

export const getSubjectAndGradesCompetences = async (userEmail) => {
  try {
    const response = await client.get("/competence/subject-grades", {
      params: { userEmail },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
